import { render, staticRenderFns } from "./ProductCreation.vue?vue&type=template&id=8557a4e4&scoped=true"
import script from "./ProductCreation.vue?vue&type=script&lang=js"
export * from "./ProductCreation.vue?vue&type=script&lang=js"
import style0 from "./ProductCreation.vue?vue&type=style&index=0&id=8557a4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8557a4e4",
  null
  
)

export default component.exports